export const loadRazorpayScript = () => {
  return new Promise((resolve) => {
    if (document.getElementById("razorpay-script")) {
      resolve(true);
      return;
    }
    const script = document.createElement("script");
    script.id = "razorpay-script";
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });
};

export const initiateRazorpayPayment = ({ amount, orderId, name, email, phone, onSuccess, onFailure }) => {
  const options = {
    key: process.env.REACT_APP_RAZORPAY_KEY_ID,
    amount: amount * 100,
    currency: "INR",
    name: "Fugus Fresh",
    description: "Order Payment",
    order_id: orderId,
    handler: function (response) {
      onSuccess(response);
    },
    prefill: {
      name: name || "",
      email: email || "",
      contact: phone || "",
    },
    theme: {
      color: "#1a6b30",
    },
    modal: {
      ondismiss: function () {
        onFailure("Payment cancelled by user");
      },
    },
  };

  const rzp = new window.Razorpay(options);
  rzp.on("payment.failed", function (response) {
    onFailure(response.error?.description || "Payment failed");
  });
  rzp.open();
};
